import { render } from "./StaffRoleManagement.vue?vue&type=template&id=7b5aa510"
import script from "./StaffRoleManagement.vue?vue&type=script&lang=js"
export * from "./StaffRoleManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__